import React, { Component } from "react";
import { connect } from "react-redux";
import HelmetComponent from "../../components/shared/Helmet";
import { axiosUserManagement } from "../../axios";

import { SiteConstants } from "../../constants/constant";
import { objectToArray, IsEmpty } from "../../util/commonFunctions";
import { updateFormElements, checkFormValid } from "../../util/FormHelper";
import Personal from "../../components/forms/UserPreferences/personal";
import Privacy from "../../components/forms/UserPreferences/privacy";
import Security from "../../components/forms/UserPreferences/security";
import PersonalConfig from "../../components/formsConfig/PersonalConfig";
import SecurityConfig from "../../components/formsConfig/SecurityConfig";
import DeletePopupConfig from "../../components/formsConfig/DeleteUserConfig";
import { setUser, logout, showLoader, hideLoader } from "../../actions";
import Modal from "../../components/shared/Modal";
import DeletePopup from "../../components/popUp/deletePopup";
import RequireAuth from "../../components/hocs/requireAuth";
import { handleActionError } from "../../util/error";

const setTimeoutMessage = 4000;
class UserPrefrences extends Component {
  state = {
    activeStep: null,
    preferencesDropdown: null,
    ...{ PersonalConfig },
    ...{ SecurityConfig },
    ...{ DeletePopupConfig },
    btnDisabled: true,
    message: null,
    success: false,
    isProfileUpdated: false,
    isPersonalInfoUpdate: false,
    isPasswordUpdated: false
  };

  onChangeHandler = (event, formName, checkButton, checkForm) => {
    const updatedFrom = updateFormElements(
      event,
      event.target.getAttribute("type"),
      this.state[formName]
    );
    const isFromUpdated = this.isFormChanged(updatedFrom);
    if (checkButton) {
      this.setState({
        [formName]: updatedFrom,
        btnDisabled:
          checkForm && checkFormValid(updatedFrom).formValid
            ? !isFromUpdated
            : !checkFormValid(updatedFrom).formValid
      });
    } else {
      this.setState({
        [formName]: updatedFrom,
        btnDisabled: !checkFormValid(updatedFrom).formValid
      });
    }
  };

  onBlurHandler = (event, formName, checkButton, checkForm) => {
    const updatedFrom = updateFormElements(
      event,
      event.target.getAttribute("type"),
      this.state[formName]
    );
    const isFromUpdated = this.isFormChanged(updatedFrom);
    if (checkButton) {
      this.setState({
        [formName]: updatedFrom,
        btnDisabled:
          checkForm && checkFormValid(updatedFrom).formValid
            ? !isFromUpdated
            : !checkFormValid(updatedFrom).formValid
      });
    } else {
      this.setState({
        [formName]: updatedFrom,
        btnDisabled: !checkFormValid(updatedFrom).formValid
      });
    }
  };

  personalHandler = formName => {
    event.preventDefault();
    let returnFormConfig = checkFormValid(this.state[formName]);

    if (returnFormConfig.formValid) {
      const formData = {};
      let config = {
        headers: {
          "cache-control": "no-cache",
          "content-type": "application/json",
          token: this.props.token
        }
      };
      this.setState({
        [formName]: returnFormConfig.form
      });
      this.props.showLoader();
      for (let formElementIdentifier in this.state[formName]) {
        formData[formElementIdentifier] = this.state[formName][
          formElementIdentifier
        ].value;
      }
      axiosUserManagement
        .put("/subscriber/details/update", formData, { ...config })
        .then(res => {
          this.getUserInfo(this.props.token);
          this.setState({
            btnDisabled: true,
            isPersonalInfoUpdate: true
          });
          let refrenceThis = this;
          setTimeout(function () {
            refrenceThis.resetProfileUpdateNotification();
          }, setTimeoutMessage);
          this.props.hideLoader();
        })
        .catch(err => {
          handleActionError("Error updating subscriber details:", err);
          this.setState({
            message: err.response.data.message
          });
          this.props.hideLoader();
        });
    } else {
      this.setState({
        [formName]: returnFormConfig.form
      });
    }
  };

  getUserInfo = token => {
    if (!IsEmpty(token)) {
      this.props.setUser(token);
    }
  };

  downloadHandler = () => {
    const config = {
      headers: {
        "cache-control": "no-cache",
        "content-type": "application/json",
        token: this.props.token
      }
    };
    axiosUserManagement
      .get("/subscriber/info/download", {
        ...config
      })
      .then(res => {
        var blob = new Blob([res.data], { type: "text/csv" });
        var hiddenElement = document.createElement("a");
        hiddenElement.href = URL.createObjectURL(blob);
        hiddenElement.target = "_blank";
        hiddenElement.download = "ausbiz_data_profile.csv";
        hiddenElement.click();
      })
      .catch(err => {
        handleActionError("Error downloading subscriber info:", err);
      });
  };

  resetProfileUpdateNotification = () => {
    this.setState({
      isPersonalInfoUpdate: false,
      isPasswordUpdated: false
    });
  };

  securityHandler = formName => {
    event.preventDefault();
    let returnFormConfig = checkFormValid(this.state[formName]);

    if (returnFormConfig.formValid) {
      const formData = {};
      let config = {
        headers: {
          "cache-control": "no-cache",
          "content-type": "application/json",
          token: this.props.token
        }
      };
      this.setState({
        [formName]: returnFormConfig.form
      });
      this.props.showLoader();
      for (let formElementIdentifier in this.state[formName]) {
        formData[formElementIdentifier] = this.state[formName][
          formElementIdentifier
        ].value;
      }
      axiosUserManagement
        .put("/subscriber/reset/password", formData, { ...config })
        .then(res => {
          this.setState({
            btnDisabled: true,
            isPasswordUpdated: true
          });
          let refrenceThis = this;
          setTimeout(function () {
            refrenceThis.resetProfileUpdateNotification();
          }, setTimeoutMessage);
          this.props.hideLoader();
        })
        .catch(err => {
          handleActionError("Error resetting subscriber password:", err);
          this.setState({
            message: err.response.data.message
          });
          this.props.hideLoader();
        });
    } else {
      this.setState({
        [formName]: returnFormConfig.form
      });
    }
  };

  DeletePopupHandler = () => {
    event.preventDefault();
    let config = {
      headers: {
        "cache-control": "no-cache",
        "content-type": "application/json",
        token: this.props.token
      }
    };
    this.props.showLoader();
    axiosUserManagement
      .get("/delete", {
        ...config
      })
      .then(res => {
        this.props.onLogout();
        this.props.hideLoader();
        this.props.history.push("/?delete=" + res.data.message);
      })
      .catch(err => {
        handleActionError("Error deleting subscriber:", err);
        this.props.hideLoader();
        this.setState({
          message: err.response.data.message
        });
      });
  };

  setTab = activeStep => {
    this.props.history.push("/profile/" + activeStep);
  };

  componentDidUpdate = prevProps => {
    if (this.props.location.pathname != prevProps.location.pathname) {
      this.setState({
        activeStep: this.props.match.params.prefrences
      });
    }
  };

  componentDidMount() {
    axiosUserManagement
      .get("/subscriberRoleAndInvestment")
      .then(res => {
        this.setState({
          preferencesDropdown: res.data.data,
          activeStep: this.props.match.params.prefrences
        });
      })
      .catch(err => {
        handleActionError("Error getting subscriber role and inevstment:", err);
      });
  }

  updateFormData = () => {
    if (!this.props.userProfile) {
      return false;
    }
    const tempData = this.state.PersonalConfig;
    let temp1Data;
    for (const key in this.props.userProfile) {
      if (Object.prototype.hasOwnProperty.call(this.props.userProfile, key)) {
        let getValue;
        if (
          typeof this.props.userProfile[key] === "object" &&
          this.props.userProfile[key]
        ) {
          getValue = this.props.userProfile[key].id;
        } else {
          getValue = this.props.userProfile[key];
        }
        if (!IsEmpty(tempData[key])) {
          temp1Data = { ...tempData[key] };
          temp1Data.value = getValue || "";
          temp1Data.valid = true;
          tempData[key] = temp1Data;
        }
      }
    }
    this.setState({
      PersonalConfig: tempData,
      isProfileUpdated: true
    });
  };

  openModalPopup = () => {
    this.setState({
      openPopup: true
    });
  };

  resetPopupProps = () => {
    this.setState({
      openPopup: false
    });
  };

  isFormChanged = form => {
    let formChanged = false;
    for (const key in this.props.userProfile) {
      if (Object.prototype.hasOwnProperty.call(this.props.userProfile, key)) {
        let matchValue;
        if (
          typeof this.props.userProfile[key] === "object" &&
          this.props.userProfile[key]
        ) {
          matchValue = this.props.userProfile[key].id;
        } else {
          matchValue = this.props.userProfile[key];
        }
        if (!IsEmpty(form[key]) && matchValue != form[key].value) {
          formChanged = true;
        }
      }
    }
    return formChanged;
  };

  render = () => (
    <React.Fragment>
      <div className="contentWhite relative">
        <div
          className={
            this.state.isPersonalInfoUpdate
              ? "profileUpdate display show"
              : "profileUpdate"
          }
        >
          Your profile has been updated
          <span
            className="clickableElement"
            onClick={() => this.resetProfileUpdateNotification()}
          >
            Close
          </span>
        </div>
        <div
          className={
            this.state.isPasswordUpdated
              ? "profileUpdate display show"
              : "profileUpdate"
          }
        >
          Your password has been updated
          <span
            className="clickableElement"
            onClick={() => this.resetProfileUpdateNotification()}
          >
            Close
          </span>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-3 formSection preferencesTab">
              <ul className="navbar-nav ">
                <li
                  className={
                    this.state.activeStep === SiteConstants.Personal
                      ? "active sidebar"
                      : "sidebar"
                  }
                  onClick={() => this.setTab(SiteConstants.Personal)}
                >
                  Personal
                </li>
                {(this.props.userProfile &&
                  this.props.userProfile.provider &&
                  this.props.userProfile.provider.toLowerCase() == "linkedin") ||
                  (this.props.userProfile &&
                    this.props.userProfile.provider &&
                    this.props.userProfile.provider.toLowerCase() == "apple") ||
                  (this.props.userProfile &&
                    this.props.userProfile.provider &&
                    this.props.userProfile.provider.toLowerCase() == "google") ? (
                  ""
                ) : (
                  <li
                    className={
                      this.state.activeStep === SiteConstants.Secruity
                        ? "active sidebar"
                        : "sidebar"
                    }
                    onClick={() => this.setTab(SiteConstants.Secruity)}
                  >
                    Password &amp; security
                  </li>
                )}
                <li
                  className={
                    this.state.activeStep === SiteConstants.DataPrivacy
                      ? "active sidebar"
                      : "sidebar"
                  }
                  onClick={() => this.setTab(SiteConstants.DataPrivacy)}
                >
                  Data &amp; privacy
                </li>
              </ul>
            </div>
            <div className="vh"></div>
            <div className="col-md-6 formSection">
              {this.state.activeStep === SiteConstants.Personal &&
                (!this.state.isProfileUpdated ? (
                  this.updateFormData()
                ) : (
                  <React.Fragment>
                    <HelmetComponent
                      title="Personal information | ausbiz"
                      subject="false"
                      description="false"
                      keywords="false"
                      noIndex="true"
                    />
                    <Personal
                      form={objectToArray(this.state.PersonalConfig)}
                      formName="PersonalConfig"
                      preferencesDropdown={this.state.preferencesDropdown}
                      btnDisabled={this.state.btnDisabled}
                      onChangeHandler={this.onChangeHandler}
                      onBlurHandler={this.onBlurHandler}
                      sucessHandler={this.personalHandler}
                      message={this.state.message}
                      userProfile={
                        this.props.userProfile &&
                        this.props.userProfile.provider
                      }
                    />
                  </React.Fragment>
                ))}
              {this.state.activeStep === SiteConstants.Secruity &&
                this.props.userProfile &&
                this.props.userProfile.provider &&
                this.props.userProfile.provider.toLowerCase() != "linkedin" ? (
                ""
              ) : (
                <React.Fragment>
                  {this.state.activeStep === SiteConstants.Secruity && (
                    <React.Fragment>
                      <HelmetComponent
                        title="Password and security | ausbiz"
                        subject="false"
                        description="false"
                        keywords="false"
                        noIndex="true"
                      />
                      <Security
                        form={objectToArray(this.state.SecurityConfig)}
                        formName="SecurityConfig"
                        btnDisabled={this.state.btnDisabled}
                        onChangeHandler={this.onChangeHandler}
                        onBlurHandler={this.onBlurHandler}
                        sucessHandler={this.securityHandler}
                        message={this.state.message}
                      />
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
              {this.state.activeStep === SiteConstants.DataPrivacy && (
                <React.Fragment>
                  <HelmetComponent
                    title="Data and privacy | ausbiz"
                    subject="false"
                    description="false"
                    keywords="false"
                    noIndex="true"
                  />
                  <Privacy
                    openModalPopup={this.openModalPopup}
                    downloadHandler={this.downloadHandler}
                  />
                  <Modal
                    openPopup={this.state.openPopup}
                    resetPopupProps={this.resetPopupProps}
                    modalID="deleteModal"
                  >
                    <DeletePopup
                      form={this.state.DeletePopupConfig}
                      formName="DeletePopupConfig"
                      btnDisabled={this.state.btnDisabled}
                      onChangeHandler={this.onChangeHandler}
                      onBlurHandler={this.onBlurHandler}
                      sucessHandler={this.DeletePopupHandler}
                      message={this.state.message}
                    />
                  </Modal>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    provider: state.auth.provider,
    userProfile: state.auth.userProfile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setUser: token => dispatch(setUser(token)),
    onLogout: () => dispatch(logout()),
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader())
  };
};

export default {
  component: RequireAuth(
    connect(mapStateToProps, mapDispatchToProps)(UserPrefrences)
  )
};
